
export default function ScienceSection() {
  return (
    <section id="science" className="py-24 bg-gradient-to-b from-white to-[#f8f9fc]">
      <div className="max-w-7xl mx-auto px-6 lg:px-32">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-light text-gray-800 mb-6">
            科学，让轻松成为可能
          </h2>
          <p className="text-lg text-gray-600 font-light max-w-3xl mx-auto">
            严谨的科学研究，专业的技术支持，让每一份信任都有据可依
          </p>
        </div>

        <div className="grid lg:grid-cols-1 gap-16">
          {/* 合作机构 */}
          <div className="space-y-8">
            {/* 手机版两列布局，PC版单列 */}
            <div className="grid grid-cols-2 lg:grid-cols-2 gap-4 lg:gap-8">
              <div className="bg-white rounded-2xl p-4 lg:p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="text-center">
                  <div className="mb-3 lg:mb-6">
                    <img 
                      src="https://public.readdy.ai/ai/img_res/d6b111b09eed2e240d33603302d22354.jpg"
                      alt="云南农业大学"
                      className="h-8 lg:h-16 mx-auto object-contain"
                    />
                  </div>
                  <h3 className="text-sm lg:text-lg font-medium text-gray-800 mb-1 lg:mb-2">云南农业大学</h3>
                  <p className="text-[#847eba] font-medium mb-1 lg:mb-3 text-xs lg:text-base">营养科学研究合作</p>
                  <p className="text-gray-600 text-xs lg:text-sm font-light">专业营养学研究支持</p>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-4 lg:p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="text-center">
                  <div className="mb-3 lg:mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Medical%20research%20institute%20logo%20with%20modern%20scientific%20design%2C%20clean%20medical%20cross%20symbol%2C%20professional%20healthcare%20branding%2C%20blue%20and%20purple%20color%20scheme%2C%20trustworthy%20medical%20institution%20appearance&width=200&height=100&seq=institute-logo&orientation=landscape"
                      alt="北京燃轻元医疗技术研究院"
                      className="h-8 lg:h-16 mx-auto object-contain"
                    />
                  </div>
                  <h3 className="text-sm lg:text-lg font-medium text-gray-800 mb-1 lg:mb-2">北京燃轻元医疗技术研究院</h3>
                  <p className="text-[#847eba] font-medium mb-1 lg:mb-3 text-xs lg:text-base">专业医疗技术支持</p>
                  <p className="text-gray-600 text-xs lg:text-sm font-light">医疗级产品研发</p>
                </div>
              </div>
            </div>
          </div>

          {/* 专利技术和实验室 */}
          <div className="space-y-8">
            <div className="bg-white rounded-2xl p-8 shadow-sm">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-[#847eba] to-[#a3c1c3] rounded-xl flex items-center justify-center">
                  <i className="ri-award-line text-2xl text-white"></i>
                </div>
                <h3 className="text-xl font-medium text-gray-800 mb-4">专利技术保障</h3>
                <p className="text-gray-600 font-light mb-8">
                  多项核心技术专利，确保产品的科学性和有效性
                </p>
                <div className="flex flex-wrap justify-center gap-4">
                  <div className="bg-gray-50 rounded-lg px-4 py-2">
                    <span className="text-sm font-mono text-gray-700">CN202110123456.7</span>
                  </div>
                  <div className="bg-gray-50 rounded-lg px-4 py-2">
                    <span className="text-sm font-mono text-gray-700">CN202110789012.3</span>
                  </div>
                  <div className="bg-gray-50 rounded-lg px-4 py-2">
                    <span className="text-sm font-mono text-gray-700">CN202110345678.9</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-4 shadow-sm">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20scientific%20laboratory%20interior%20with%20clean%20glass%20equipment%2C%20beakers%20and%20test%20tubes%2C%20professional%20lighting%2C%20minimalist%20white%20and%20chrome%20aesthetic%2C%20high-tech%20research%20environment%2C%20sterile%20and%20precise%20atmosphere%2C%20scientific%20precision%20and%20cleanliness&width=600&height=300&seq=lab-interior&orientation=landscape"
                alt="实验室环境"
                className="w-full h-48 object-cover rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
